import { MensagemModel } from "./mensagem-model"

export class MensagemKafkaEnvio {
    dados!: MensagemModel
}
